import ExportDataView from './views/ExportDataView.vue';
import ImportDataView from './views/ImportDataView.vue';
import AuditRecordsView from './views/AuditRecordsView.vue';
import ExcelExportView from './views/ExcelExportView.vue';

export default [
  { path: '/admin/data/export', name: 'admin/data/export', component: ExportDataView, meta: { role: 'DataAdmin', title: 'Export Data' } },
  { path: '/admin/data/import', name: 'admin/data/import', component: ImportDataView, meta: { role: 'DataAdmin', title: 'Import Data' } },

  { path: '/admin/data/audit-records', name: 'admin/data/audit-records', component: AuditRecordsView, meta: { role: 'DataAdmin', title: 'Audit Records' } },

  { path: '/admin/excel-export', name: 'admin/excel-export', component: ExcelExportView, meta: { role: 'DataAdmin', title: 'Excel Export' } },
]



// WEBPACK FOOTER //
// ./src/dataAdmin/routes.js